import request from '../utils/request'

export const getUsageGuide = (language = 'zh') => request({ url: '/transport/usage-guide', method: 'GET', params: { language }, headers: { 'Cache-Control': 'no-cache' }, silentError: true })
export const publishUsageGuide = data => request({ url: '/admin/transport/usage-guide', method: 'PUT', data, silentError: true })
